var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommenting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3756 15.7723H40.0634V18.2958C40.0634 23.5008 35.8048 27.6017 30.5999 27.6017H16.7201L12.7769 31.5448V33.9106C12.7769 37.5382 15.7738 40.5351 19.4015 40.5351H34.3853L44.0065 49.9986V40.5351C47.3187 40.2196 50.0001 37.3806 50.0001 33.9106V22.3966C50.0001 18.769 47.0034 15.7723 43.3756 15.7723ZM6.7821 0H30.5987C34.3841 0 37.3809 2.99677 37.3809 6.78211V18.296C37.3809 21.9239 34.3841 24.9206 30.5987 24.9206H15.6148L5.99357 34.3841V24.9206C2.68133 24.6051 0 21.7661 0 18.296V6.78211C0 2.99677 2.99677 0 6.7821 0Z",
    fill: "#061240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommenting);
export default __webpack_public_path__ + "static/media/commenting.37df8e13.svg";
export { ForwardRef as ReactComponent };